<template>
  <div :class="device" class="quantities-section-wrapper">
    <div class="cover1" />

    <div class="wrapper">
      <section class="desc">
        <div :class="titleResp" class="description-2">
          “150 million new Data-AI related jobs will be created in the next two
          years.”
          <br />
          <div>
            <img
              class="logo"
              v-lazy-load data-src="~/assets/img/landing-page/hero-block/wef-logo.png"
              alt=""
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// In your Vue.js component.

import "vueperslides/dist/vueperslides.css";

export default {
  components: {},

  computed: {
    titleResp() {
      switch (this.$mq) {
        case "desktop":
          return "text";
        default:
          return "text-mobile";
      }
    },
    device() {
      switch (this.$mq) {
        case "desktop":
          return "";
        case "tablet":
          return "tablet";
        default:
          return "mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
%wrapper {
  background: $primary-yellow;
  display: flex;
  flex-direction: column;
  padding: 4rem 1.5rem;

  .cards {
    margin: 3rem 0;
  }

  .description-2 {
    max-width: 900px;
  }
}
.quantities-section-wrapper {
  @extend %wrapper;
  &.mobile {
    padding: 2rem 1.5rem;
  }
}

.desc {
  margin-left: 1rem;
}
/***************FONT**************** */
.title-mobile {
  font-weight: 800;
  font-size: 32px;
  line-height: 36px;
  letter-spacing: -0.8px;
}
.text {
  font-weight: 600;
  font-size: 36px;
  line-height: 47.09px;
  letter-spacing: 0.03px;
}

.text-mobile {
  font-weight: 700;
  font-size: 24px;
  line-height: 31.39px;
  letter-spacing: 0.03px;
}
/*************************END FONT******************************* */
.inv {
  color: transparent;
}

.logo {
  height: 60px;
  width: auto;
  margin-right: 1rem;
  margin-top: 1.5rem;
}
</style>
